<template>
  <quick-actions v-if="isVisible" />
  <quick-actions-modals />
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";

import useQuickActionsStore from "@/stores/quickActions";

import QuickActions from "@/components/communication/standalone/QuickActions.vue";
import QuickActionsModals from "@/components/communication/standalone/QuickActionsModals.vue";

const { isVisible } = storeToRefs(useQuickActionsStore());
</script>
